<template>
  <div class="p-2 rounded-xl min-h-screen">

    <div
        v-show="mobileFiltersOpen || isDesktop"
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 mb-4 shadow-sm border border-gray-100 relative z-30"
    >
      <div class="grid grid-cols-2 md:flex md:flex-wrap gap-3">
        <div class="col-span-2 md:w-32">
          <searchable-select
              v-model="filters.brand_in"
              :options="brands"
              placeholder="همه برندها"
              class="w-full backdrop-blur-xl"
              style="z-index: 999999"
              @change="applyFilters"
          />
        </div>

        <div class="col-span-2 md:w-32">
          <input
              v-model="filters.search_value"
              placeholder="نام محصول"
              class="px-3 py-3 bg-gray-100 text-sm rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>

        <div class="md:w-32">
          <input
              v-model="filters.sku"
              placeholder="SKU"
              class="px-3 py-3 bg-gray-100 text-sm rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>

        <div class="md:w-32">
          <input
              v-model="filters.id_in"
              placeholder="شناسه"
              class="px-3 py-3 bg-gray-100 text-sm rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
      </div>
    </div>
    <div class="mb-3 flex items-center gap-2 md:hidden">
      <button
          @click="mobileFiltersOpen = !mobileFiltersOpen"
          class="px-2 py-1 rounded-lg text-[12px] text-center items-center bg-white/10 border border-white/10 hover:bg-white/15 flex-1"
      >
        {{ mobileFiltersOpen ? 'بستن فیلترها' : 'نمایش فیلترها' }}
      </button>

      <button
          @click="resetFilters"
          class="px-2 py-1 rounded-lg text-[12px] text-center items-center bg-gradient-to-r from-gray-500 to-blue-600 text-white flex-1"
      >
        ریست
      </button>

      <button
          @click="applyFilters"
          class="px-2 py-1 rounded-lg text-[12px] text-center items-center bg-gradient-to-r from-red-500 to-blue-600 text-white flex-1"
      >
        اعمال
      </button>
    </div>

    <!-- ============ BULK ACTIONS BAR (موبایل) ============
    <div v-if="selectedCount > 0"
         class="mb-4 p-3 bg-gradient-to-r from-violet-500/20 to-fuchsia-500/20 backdrop-blur-lg rounded-xl border border-white/10 sticky top-2 z-40">
      <div class="flex items-center justify-between">
        <span class="text-[10px] text-white">{{ selectedCount }}  محصول انتخاب شده</span>
        <button
            @click="toggleSelectAllManual"
            class="px-2 py-1 mr-2 ml-3 rounded-full text-[10px] bg-gradient-to-r from-blue-500 to-green-600 "
        >
          {{ isAllSelected ? 'لغو همه' : ' همه' }}
        </button>
        <div class="flex gap-2">
          <button
              @click="clearSelected"
              class="px-2 py-1  mr-2 rounded-full text-[10px] border border-white/10 bg-white/5"
          >
            پاک کردن
          </button>
          <button
              @click="openBulkDialog('status')"
              class="px-2 py-1 rounded-full text-[10px] bg-gradient-to-r from-violet-500 to-fuchsia-600 text-white"
          >
            وضعیت
          </button>
          <button
              @click="openBulkDialog('content_status')"
              class="px-2 py-1 rounded-full text-[10px] bg-gradient-to-r from-emerald-500 to-cyan-600 text-white"
          >
            محتوا
          </button>
        </div>
      </div>
    </div>
    -->
    <!-- ============ LIST - کارت‌های عمودی برای موبایل ============ -->
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100"
         ref="listRoot">

      <!-- نمای موبایل (کارت‌ها) -->
      <div class="block md:hidden">
        <div v-if="loading" class="p-8 text-center">
          <div class="flex justify-center items-center gap-2">
            <svg class="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="text-sm">در حال بارگذاری...</span>
          </div>
        </div>

        <div v-else-if="products.length === 0" class="p-8 text-center text-gray-500 text-sm">
          محصولی یافت نشد
        </div>

        <div v-else class="divide-y divide-white/10">
          <div v-for="product in products" :key="product.id" class="p-4">
            <!-- کارت محصول اصلی -->
            <div class="mb-2">
              <div class="flex items-start gap-3">
                <!-- چک‌باکس بزرگ‌تر -->
                <div class="pt-1">
                  <input
                      type="checkbox"
                      class="h-6 w-6 rounded border border-white/30 bg-white/10"
                      :checked="selectedIdsSet.has(product.id)"
                      @change="toggleRowSelect(product.id, $event)"
                  />
                </div>

                <div class="flex-shrink-0" @click.stop="openRowImageDialog(product)">
                  <img

                      v-if="product.image"
                      :src="img_source(product.image)"
                      class="w-20 h-20 rounded-xl object-cover border-2 border-white/20 shadow-lg"
                  />
                  <div v-else class="w-20 h-20 rounded-xl border-2 border-white/20 bg-white/10"></div>
                </div>

                <!-- اطلاعات محصول -->
                <div class="flex-1 min-w-0">
                  <div class="flex items-start justify-between gap-2">
                    <div>
                      <h3 class="text-sm font-bold text-white break-words">{{ product.name }}</h3>
                      <div class="flex items-center gap-2 mt-1 flex-wrap">
                        <span class="text-[10px] bg-white/10 px-2 py-1 rounded-full"
                              v-if="product.product_type !== 'variable'">
                          {{ product.sixteen_digit_code || '—' }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- وضعیت‌ها -->
                  <div class="flex items-center gap-2 mt-2 flex-wrap">
                    <span v-if="product.product_type === 'variable'"
                          class="text-[10px] bg-violet-500/30 px-2 py-1 rounded-full text-violet-200">
                          متغیردار
                    </span>
                    <span v-else
                          class="text-[10px] bg-pink-500/30 px-2 py-1 rounded-full text-pink-200">
                          ساده
                    </span>
                    <span class="px-2 py-1 rounded-full text-[10px] font-medium"
                          :class="{
                            'bg-green-500/20 text-green-300': product.status === 'publish',
                            'bg-yellow-500/20 text-yellow-300': product.status === 'pending',
                            'bg-orange-500/20 text-orange-300': product.status === 'pr',
                            'bg-gray-500/20 text-gray-300': product.status === 'draft',
                            'bg-red-500/20 text-red-300': product.status === 'archived'
                          }">
                      {{ getStatusLabel(product.status) }}
                    </span>


                    <!-- وضعیت محتوا -->
                    <span class="px-2 py-1 rounded-full text-[10px] font-medium"
                          :class="{
                            'bg-green-500/20 text-green-300': product.content_status === 'approved',
                            'bg-yellow-500/20 text-yellow-300': product.content_status === 'done_pending',
                            'bg-red-500/20 text-red-300': product.content_status === 'waiting'
                          }">
                      {{ getContentStatusLabel(product.content_status) }}
                    </span>
                  </div>

                  <!--
                  <div class="flex items-center gap-2 mt-3">
                    <button @click.stop="openRowImageDialog(product)"
                            class="p-2.5 bg-gray-700 rounded-xl border border-gray-600"
                            title="تغییر عکس">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-sky-300" viewBox="0 0 24 24"
                           fill="currentColor">
                        <path
                            d="M21 19V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2zM8.5 11.5L11 14l3.5-4.5L19 16H5l3.5-4.5z"/>
                      </svg>
                    </button>

                    <button @click.stop="openRowStatusDialog(product)"
                            class="p-2.5 bg-gray-700 rounded-xl border border-gray-600"
                            title="تغییر وضعیت">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-amber-300" viewBox="0 0 24 24"
                           fill="currentColor">
                        <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 14.5h-2v-2h2v2zM13 12h-2V6h2v6z"/>
                      </svg>
                    </button>

                    <button @click.stop="openRowContentStatusDialog(product)"
                            class="p-2.5 bg-gray-700 rounded-xl border border-gray-600"
                            title="تغییر وضعیت محتوا">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-emerald-300" viewBox="0 0 24 24"
                           fill="currentColor">
                        <path d="M9 16.2l-3.5-3.5L4 14.2l5 5 11-11-1.5-1.5-9.5 9.5z"/>
                      </svg>
                    </button>
                  </div>
                  -->
                </div>
              </div>
            </div>

            <!-- Variations برای موبایل - با کلیک باز می‌شن -->
            <div v-if="product.product_type === 'variable' && product.variations.length" class="mr-9 mt-2 space-y-2">
              <div class="text-xs text-gray-400 mb-1">متغیرها:</div>
              <div v-for="(v, idx) in product.variations" :key="'v-' + (v.id || idx)"
                   @click.stop="openRowImageDialog(v)"
                   class="bg-white/5 rounded-xl p-3 border border-white/10 cursor-pointer hover:bg-white/10 transition-colors">
                <div class="flex items-center gap-2">
                  <img v-if="v.image" :src="img_source(v.image)"
                       class="w-12 cursor-pointer h-10 rounded-lg object-cover"/>
                  <div v-else class="w-12 h-12 rounded-lg bg-white/10"></div>
                  <div class="flex-1">
                    <div class="text-xs font-bold text-white">{{ v.name }}</div>
                    <div class="text-[9px] text-gray-400 mt-0.5">{{ v.sixteen_digit_code || '—' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- نمای دسکتاپ (جدول) - بدون تغییر
      <div class="hidden md:block overflow-x-auto" ref="tableWrap">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 text-right w-10">
              <input type="checkbox" class="h-4 w-4 rounded border border-white/20 bg-white/10"
                     :checked="isAllSelected" @change="toggleSelectAll($event)"/>
            </th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">محصول</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">وضعیت</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">محتوا</th>
            <th class="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading && products.length === 0">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">...</div>
            </td>
          </tr>
          <template v-else>
            <tr v-for="product in products" :key="product.id" class="border-t border-gray-100 hover:bg-gray-50">
              <td class="p-3">
                <input type="checkbox" class="h-4 w-4 rounded border border-white/20 bg-white/10"
                       :value="product.id" :checked="selectedIdsSet.has(product.id)"
                       @change="toggleRowSelect(product.id, $event)"/>
              </td>
              <td class="p-3">
                <div class="flex items-center gap-3">
                  <img v-if="product.image" :src="img_source(product.image)" class="w-10 h-10 rounded-lg object-cover"/>
                  <div v-else class="w-10 h-10 rounded-lg bg-white/10"></div>
                  <div class="text-xs font-medium">{{ product.name }}</div>
                </div>
              </td>
              <td class="p-3 text-xs">{{ product.sixteen_digit_code || '—' }}</td>
              <td class="p-3">
                  <span class="px-2 py-1 rounded-full text-[10px]"
                        :class="{
                          'bg-green-100 text-green-800': product.status === 'publish',
                          'bg-yellow-100 text-yellow-800': product.status === 'pending',
                          'bg-orange-100 text-orange-800': product.status === 'pr'
                        }">{{ getStatusLabel(product.status) }}</span>
              </td>
              <td class="p-3">
                  <span class="px-2 py-1 rounded-full text-[10px]"
                        :class="{
                          'bg-green-100 text-green-800': product.content_status === 'approved',
                          'bg-yellow-100 text-yellow-800': product.content_status === 'done_pending',
                          'bg-red-100 text-red-800': product.content_status === 'waiting'
                        }">{{ getContentStatusLabel(product.content_status) }}</span>
              </td>
              <td class="p-3 text-left">
                <button @click.stop="openRowImageDialog(product)" class="p-1.5 bg-gray-700 rounded-lg ml-1">📷</button>
                <button @click.stop="openRowStatusDialog(product)" class="p-1.5 bg-gray-700 rounded-lg ml-1">⚡</button>
                <button @click.stop="openRowContentStatusDialog(product)" class="p-1.5 bg-gray-700 rounded-lg">✓
                </button>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      -->
      <!-- Pagination -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="flex items-center gap-2 w-full md:w-auto justify-between md:justify-start">
          <label class="text-xs text-gray-400">تعداد:</label>
          <select v-model.number="itemsPerPage" @change="changePerPage"
                  class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-24 text-right">
            <option :value="10">۱۰</option>
            <option :value="20">۲۰</option>
            <option :value="50">۵۰</option>
            <option :value="100">۱۰۰</option>
          </select>
          <span class="text-xs text-gray-400 mr-2">
            {{ (currentPage - 1) * itemsPerPage + 1 }}-{{ Math.min(currentPage * itemsPerPage, totalProducts) }}
          </span>
        </div>

        <div class="flex gap-1 justify-center w-full md:w-auto">
          <button @click="prevPage" :disabled="currentPage === 1"
                  class="p-2 border border-gray-200 rounded-lg bg-white/10 disabled:opacity-40">
            →
          </button>
          <span class="px-3 py-2 text-sm">{{ currentPage }} / {{ Math.ceil(totalProducts / itemsPerPage) }}</span>
          <button @click="nextPage" :disabled="currentPage * itemsPerPage >= totalProducts"
                  class="p-2 border border-gray-200 rounded-lg bg-white/10 disabled:opacity-40">
            ←
          </button>
        </div>
      </div>
    </div>


    <!-- Row Status Dialog
    <v-dialog v-model="dialogs.rowStatus.open" max-width="520" content-class="dark-v-dialog">
      <v-card class="rounded-2xl overflow-hidden">
        <div class="px-4 py-3 bg-gray-900/70 border-b border-white/10 flex items-center justify-between">
          <div class="text-sm font-extrabold text-white">تغییر وضعیت محصول</div>
          <button class="p-2 rounded-lg hover:bg-white/10" @click="closeDialogs">
            <v-icon color="white">fa-times</v-icon>
          </button>
        </div>

        <div class="p-4 space-y-3">
          <div class="text-[12px] text-slate-300">
            محصول:
            <span class="font-bold text-white">
                            {{
                (dialogs.rowStatus.product && dialogs.rowStatus.product.name) ? dialogs.rowStatus.product.name : '—'
              }}

            </span>
          </div>

          <div class="bg-white/5 rounded-xl border border-white/10 p-3">
            <label class="text-[11px] text-slate-300 block mb-2">وضعیت جدید</label>
            <select v-model="dialogs.rowStatus.value"
                    class="w-full px-3 py-2 rounded-xl bg-white/5 border border-white/10 text-[12px]">
              <option value="pr">نیاز به بررسی</option>
              <option value="pending">در انتظار تایید</option>
              <option value="draft">پیش نویس</option>
              <option value="publish">منتشر شده</option>
            </select>
          </div>

          <div class="flex items-center justify-end gap-2 pt-2">
            <button class="px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-[12px]"
                    @click="closeDialogs">
              انصراف
            </button>

            <button
                class="px-4 py-2 rounded-xl text-[12px] font-bold bg-gradient-to-r from-violet-500/70 to-fuchsia-500/60 border border-white/10"
                :disabled="dialogs.busy"
                @click="confirmRowStatus"
            >
              تایید و ذخیره
            </button>
          </div>
        </div>
      </v-card>
    </v-dialog>
    -->
    <!-- Row Content Dialog
    <v-dialog v-model="dialogs.rowContent.open" max-width="520" content-class="dark-v-dialog">
      <v-card class="rounded-2xl overflow-hidden">
        <div class="px-4 py-3 bg-gray-900/70 border-b border-white/10 flex items-center justify-between">
          <div class="text-sm font-extrabold text-white">تغییر وضعیت محتوای محصول</div>
          <button class="p-2 rounded-lg hover:bg-white/10" @click="closeDialogs">
            <v-icon color="white">fa-times</v-icon>
          </button>
        </div>

        <div class="p-4 space-y-3">
          <div class="text-[12px] text-slate-300">
            محصول:
            <span class="font-bold text-white">
              {{
                (dialogs.rowContent.product && dialogs.rowContent.product.name) ? dialogs.rowContent.product.name : '—'
              }}
            </span>
          </div>

          <div class="bg-white/5 rounded-xl border border-white/10 p-3">
            <label class="text-[11px] text-slate-300 block mb-2">وضعیت جدید</label>
            <select v-model="dialogs.rowContent.value"
                    class="w-full px-3 py-2 rounded-xl bg-white/5 border border-white/10 text-[12px]">
              <option value="waiting">در انتظار محتوا</option>
              <option value="done_pending">در انتظار تایید</option>
              <option value="approved">تایید شده</option>
            </select>
          </div>

          <div class="flex items-center justify-end gap-2 pt-2">
            <button class="px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-[12px]"
                    @click="closeDialogs">
              انصراف
            </button>

            <button
                class="px-4 py-2 rounded-xl text-[12px] font-bold bg-gradient-to-r from-emerald-500/60 to-cyan-500/50 border border-white/10"
                :disabled="dialogs.busy"
                @click="confirmRowContentStatus"
            >
              تایید و ذخیره
            </button>
          </div>
        </div>
      </v-card>
    </v-dialog>
 -->


    <div v-if="dialogs.rowImage.open" class="fixed top-0 inset-0 z-50 dark-v-dialog">
      <div class=" top-0 flex items-center justify-center " @click.self="closeDialogs">
        <div class=" w-[70vw] h-[100vh] overflow-y-auto mt-10">
          <v-card class="rounded-2xl overflow-hidden">
            <div class="px-4 py-3 bg-gray-900/70 border-b border-white/10 flex items-center justify-between">
              <div class="text-sm font-extrabold text-white">تغییر عکس محصول</div>
              <button class="p-2 rounded-lg hover:bg-white/10" @click="closeDialogs">
                <v-icon color="white">fa-times</v-icon>
              </button>
            </div>

            <div class="p-4 space-y-4">
              <div class="text-[12px] text-slate-300">
                محصول:
                <span class="font-bold text-white">
              {{ (dialogs.rowImage.product && dialogs.rowImage.product.name) ? dialogs.rowImage.product.name : '—' }}

            </span>
              </div>

              <div class="grid grid-cols-2 gap-3">
                <div class="bg-white/5 rounded-xl border border-white/10 p-3">
                  <div class="text-[11px] text-slate-300 mb-2">عکس فعلی</div>
                  <img
                      v-if="dialogs.rowImage.product && dialogs.rowImage.product.image"
                      :src="img_source(dialogs.rowImage.product.image)"
                      class="w-full h-44 object-cover rounded-xl border border-white/10"
                  />
                  <div v-else
                       class="h-44 rounded-xl border border-white/10 flex items-center justify-center text-[11px] text-slate-400">
                    ندارد
                  </div>
                </div>

                <div class="bg-white/5 rounded-xl border border-white/10 p-3">
                  <div class="text-[11px] text-slate-300 mb-2">عکس جدید</div>
                  <smart-image-picker-modal
                      :accept="'image/*'"
                      :max-size-m-b="10"
                      :hint="'حداکثر ۱۰MB'"
                      :value="dialogs.rowImage.pickerValue"
                      @input="onRowImageSmartPicked"
                      @cleared="onRowImageSmartCleared"
                  />
                </div>
              </div>

              <div class="flex items-center justify-end gap-2 pt-2">
                <button class="px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-[12px]"
                        @click="closeDialogs">
                  انصراف
                </button>

                <button
                    class="px-4 py-2 rounded-xl text-[12px] font-bold bg-gradient-to-r from-sky-500/60 to-indigo-500/50 border border-white/10"
                    :disabled="dialogs.busy || !(dialogs.rowImage.pickerValue && dialogs.rowImage.pickerValue.file)"
                    @click="confirmRowImage"
                >
                  آپلود و ذخیره
                </button>
              </div>
            </div>
          </v-card>

        </div>
      </div>
    </div>



    <!-- Bulk Dialog
    <v-dialog v-model="dialogs.bulk.open" max-width="520" content-class="dark-v-dialog">
      <v-card class="rounded-2xl overflow-hidden">
        <div class="px-4 py-3 bg-gray-900/70 border-b border-white/10 flex items-center justify-between">
          <div class="text-sm font-extrabold text-white">
            {{ dialogs.bulk.mode === 'status' ? 'تغییر وضعیت گروهی' : 'تغییر وضعیت محتوای گروهی' }}
          </div>
          <button class="p-2 rounded-lg hover:bg-white/10" @click="closeDialogs">
            <v-icon color="white">fa-times</v-icon>
          </button>
        </div>

        <div class="p-4 space-y-3">
          <div class="text-[12px] text-slate-300">
            تعداد انتخاب شده:
            <span class="font-extrabold text-white">{{ selectedCount }}</span>
          </div>

          <div class="bg-white/5 rounded-xl border border-white/10 p-3">
            <label class="text-[11px] text-slate-300 block mb-2">مقدار جدید</label>

            <select
                v-if="dialogs.bulk.mode === 'status'"
                v-model="dialogs.bulk.value"
                class="w-full px-3 py-2 rounded-xl bg-white/5 border border-white/10 text-[12px]"
            >
              <option value="pr">نیاز به بررسی</option>
              <option value="pending">در انتظار تایید</option>
              <option value="draft">پیش نویس</option>
              <option value="publish">منتشر شده</option>
            </select>

            <select
                v-else
                v-model="dialogs.bulk.value"
                class="w-full px-3 py-2 rounded-xl bg-white/5 border border-white/10 text-[12px]"
            >
              <option value="waiting">در انتظار محتوا</option>
              <option value="done_pending">در انتظار تایید</option>
              <option value="approved">تایید شده</option>
            </select>
          </div>

          <div class="flex items-center justify-end gap-2 pt-2">
            <button class="px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-[12px]"
                    @click="closeDialogs">
              انصراف
            </button>

            <button
                class="px-4 py-2 rounded-xl text-[12px] font-bold bg-gradient-to-r from-amber-500/60 to-rose-500/50 border border-white/10"
                :disabled="dialogs.busy || selectedCount === 0"
                @click="confirmBulkUpdate"
            >
              تایید و اعمال
            </button>
          </div>
        </div>
      </v-card>
    </v-dialog>
    -->
  </div>
</template>

<script>
import SearchableSelect from "@/components/selects/SearchableSelect";
import SmartImagePickerModal from "@/components/scomponents/SmartImagePicker";

export default {
  name: 'AdminProductListLite',
  components: {
    SearchableSelect,
    SmartImagePickerModal,
  },
  data() {
    return {
      mobileFiltersOpen: false,
      selectedIdsSet: new Set(),

      dialogs: {
        busy: false,
        rowStatus: {open: false, product: null, value: 'draft'},
        rowContent: {open: false, product: null, value: 'waiting'},
        rowImage: {open: false, product: {name: '', image: null}, pickerValue: null},
        bulk: {open: false, mode: 'status', value: ''},
      },

      navigatingOut: false,

      showQuickView: false,
      selectedProduct: null,

      showVariationForm: false,
      editingVariation: null,
      editingProductId: null,

      loading: true,
      products: [],
      totalProducts: 0,
      currentPage: 1,
      itemsPerPage: 10,

      filters: {
        id_in: '',
        search_value: '',
        sku: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        status_in: '',
        content_status: '',
        catalog_need: '',
        currency_in: '',
        is_ai: null,
        supplier: ''
      },

      brands: [],
      avails: [],
      features: [],
      currencies: []
    }
  },
  computed: {
    isDesktop() {
      return typeof window !== 'undefined' ? window.innerWidth >= 768 : true;
    },
    selectedCount() {
      return this.selectedIdsSet ? this.selectedIdsSet.size : 0;
    },
    selectedIds() {
      return Array.from(this.selectedIdsSet || []);
    },
    isAllSelected() {
      const ids = (this.products || []).filter(p => p && p.id != null).map(p => p.id);
      if (!ids.length) return false;
      return ids.every(id => this.selectedIdsSet.has(id));
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage);
      const range = 1;
      const pages = [];
      pages.push(1);
      if (this.currentPage - range > 2) pages.push('...');
      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i);
      }
      if (this.currentPage + range < totalPages - 1) pages.push('...');
      if (totalPages > 1) pages.push(totalPages);
      return pages;
    }
  },
  methods: {
    toggleSelectAllManual() {
      const checked = !this.isAllSelected;
      const fakeEvt = {target: {checked}};
      this.toggleSelectAll(fakeEvt);
    },
    _requestSafe(opts) {
      return new Promise((resolve) => {
        this.loading = true;
        let done = false;
        const finish = (ok) => {
          if (done) return;
          done = true;
          resolve(ok);
        };
        const t = setTimeout(() => finish(false), 12000);
        this.request({
          ...opts,
          success: (data) => {
            clearTimeout(t);
            finish(true);
            opts.success && opts.success(data);
          },
          error: (err) => {
            clearTimeout(t);
            finish(false);
            opts.error && opts.error(err);
            this.loading = false
          },
          complete: () => {
            opts.complete && opts.complete();
            this.loading = false

          }
        });
      });
    },

    // ---- image picker handlers ----
    onRowImageSmartPicked(payload) {
      if (!payload) {
        this.dialogs.rowImage.pickerValue = null;
        return;
      }
      if (payload instanceof File) {
        this.dialogs.rowImage.pickerValue = {file: payload, preview: ''};
        return;
      }
      this.dialogs.rowImage.pickerValue = payload;
    },
    onRowImageSmartCleared() {
      this.dialogs.rowImage.pickerValue = null;
    },

    // ---- selection ----
    clearSelected() {
      this.selectedIdsSet = new Set();
    },
    toggleRowSelect(id, evt) {
      const checked = !!evt.target.checked;
      const next = new Set(this.selectedIdsSet || []);
      if (checked) next.add(id);
      else next.delete(id);
      this.selectedIdsSet = next;
    },
    toggleSelectAll(evt) {
      const checked = !!evt.target.checked;
      const ids = (this.products || []).filter(p => p && p.id != null).map(p => p.id);
      if (!ids.length) return;
      this.selectedIdsSet = checked ? new Set(ids) : new Set();
    },

    // ---- dialogs open/close ----
    closeDialogs() {
      this.dialogs.rowStatus.open = false;
      this.dialogs.rowContent.open = false;
      this.dialogs.rowImage.open = false;
      this.dialogs.bulk.open = false;

      this.dialogs.rowStatus.product = null;
      this.dialogs.rowContent.product = null;
      this.dialogs.rowImage.product = {name: '', image: null};
      this.dialogs.rowImage.pickerValue = null;
    },
    openRowStatusDialog(product) {
      if (!product) return;
      this.dialogs.rowStatus.product = product;
      this.dialogs.rowStatus.value = product.status || 'draft';
      this.dialogs.rowStatus.open = true;
    },
    openRowContentStatusDialog(product) {
      if (!product) return;
      this.dialogs.rowContent.product = product;
      this.dialogs.rowContent.value = product.content_status || 'waiting';
      this.dialogs.rowContent.open = true;
    },
    openRowImageDialog(product) {
      if (!product) return;
      this.dialogs.rowImage.product = product;
      this.dialogs.rowImage.pickerValue = null;
      this.dialogs.rowImage.open = true;
    },

    openBulkDialog(mode) {
      this.dialogs.bulk.mode = mode; // 'status' | 'content_status'
      this.dialogs.bulk.value = mode === 'status' ? 'draft' : 'waiting';
      this.dialogs.bulk.open = true;
    },

    // ---- PATCH / UPLOAD ----
    async _patchProduct(productId, payload, {silent = false} = {}) {
      this.dialogs.busy = true;
      const url = this.endpoint(`product/adminProductStatus/${productId}`);
      try {
        const ok = await this._requestSafe({
          url,
          method: 'put',
          data: payload,
        });
        if (ok && !silent) await this.fetchProducts();
        return ok;
      } finally {
        this.dialogs.busy = false;
      }
    },
    async _uploadProductImage(productId, file) {
      this.dialogs.busy = true;
      const url = this.endpoint(`product/adminProductImage/${productId}`);
      const fd = new FormData();
      fd.append('image', file);
      try {
        const ok = await this._requestSafe({
          url,
          method: 'put',
          data: fd,
          headers: {'Content-Type': 'multipart/form-data'},
        });
        if (ok) await this.fetchProducts();
        return ok;
      } finally {
        this.dialogs.busy = false;
      }
    },

    async confirmRowStatus() {
      const p = this.dialogs.rowStatus.product;
      const value = this.dialogs.rowStatus.value;
      if (!p || !p.id) return;
      await this._patchProduct(p.id, {status: value});
      this.closeDialogs();
    },
    async confirmRowContentStatus() {
      const p = this.dialogs.rowContent.product;
      const value = this.dialogs.rowContent.value;
      if (!p || !p.id) return;
      await this._patchProduct(p.id, {content_status: value});
      this.closeDialogs();
    },
    async confirmRowImage() {
      const p = this.dialogs.rowImage.product;
      const payload = this.dialogs.rowImage.pickerValue;
      const file = payload && payload.file ? payload.file : null;
      if (!p.id || !file) return;
      await this._uploadProductImage(p.id, file);
      this.closeDialogs();
    },

    async confirmBulkUpdate() {
      const mode = this.dialogs.bulk.mode;
      const value = this.dialogs.bulk.value;
      const ids = this.selectedIds;
      if (!ids.length) return;

      const chunks = [];
      const size = 8;
      for (let i = 0; i < ids.length; i += size) chunks.push(ids.slice(i, i + size));

      this.dialogs.busy = true;
      try {
        for (const chunk of chunks) {
          await Promise.all(
              chunk.map(id => this._patchProduct(
                  id,
                  mode === 'status' ? {status: value} : {content_status: value},
                  {silent: true}
              ))
          );
        }
        await this.fetchProducts();
      } finally {
        this.dialogs.busy = false;
      }

      this.closeDialogs();
      this.clearSelected();
    },

    // ---- variation popup ----
    openVariationPopup(product, variation) {
      this.editingProductId = product.id;
      this.editingVariation = variation || null;
      this.showVariationForm = true;
    },
    closeVariationPopup() {
      this.showVariationForm = false;
      this.editingVariation = null;
      this.editingProductId = null;
    },
    onVariationSaved() {
      this.fetchProducts();
      this.closeVariationPopup();
    },
    onVariationChanged() {
      this.fetchProducts();
    },
    onVariationDone() {
      this.fetchProducts();
      this.closeVariationPopup();
    },
    onVariationCancel() {
      this.closeVariationPopup();
    },

    // ---- query state ----
    loadStateFromQuery() {
      const q = this.$route.query || {};
      const strKeys = ['id_in', 'search_value', 'sku', 'category_tree', 'status_in', 'content_status'];
      strKeys.forEach(k => {
        if (q[k] != null) this.filters[k] = q[k];
      });

      const intKeys = ['min_price', 'max_price', 'min_inventory', 'max_inventory', 'brand_in', 'currency_in', 'supplier'];
      intKeys.forEach(k => {
        if (q[k] != null && q[k] !== '') {
          const n = Number(q[k]);
          if (!isNaN(n)) this.filters[k] = n;
        }
      });

      if (q.page != null && q.page !== '') {
        const p = Number(q.page);
        if (!isNaN(p)) this.currentPage = p;
      }
      if (q.per_page != null && q.per_page !== '') {
        const pp = Number(q.per_page);
        if (!isNaN(pp)) this.itemsPerPage = pp;
      }

      if (q.catalog_need != null) {
        if (q.catalog_need === 'true') this.filters.catalog_need = true;
        else if (q.catalog_need === 'false') this.filters.catalog_need = false;
        else this.filters.catalog_need = '';
      }
    },
    persistStateToQuery(replace = true) {
      if (this.navigatingOut) return;
      if (this.$route.name !== this.$options.name) return;

      const rawQuery = {
        ...Object.fromEntries(Object.entries(this.filters).map(([k, v]) => [k, v ?? ''])),
        page: this.currentPage,
        per_page: this.itemsPerPage,
      };

      const query = {};
      Object.keys(rawQuery).forEach(k => {
        const v = rawQuery[k];
        if (v !== '' && v != null) query[k] = v;
      });

      const current = this.$route.query || {};
      if (JSON.stringify(current) === JSON.stringify(query)) return;

      const nav = {name: this.$route.name, query};
      const op = replace ? this.$router.replace(nav) : this.$router.push(nav);
      return op.catch(err => {
        if (!err || err.name === 'NavigationDuplicated') return;
        throw err;
      });
    },

    // ---- list actions ----
    applyFilters() {
      this.currentPage = 1;
      this.persistStateToQuery(true);
      this.fetchProducts();
      this.mobileFiltersOpen = false
    },
    changePerPage() {
      this.currentPage = 1;
      this.persistStateToQuery(true);
      this.fetchProducts();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.persistStateToQuery(true);
        this.fetchProducts();
      }
    },
    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++;
        this.persistStateToQuery(true);
        this.fetchProducts();
      }
    },
    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page;
        this.persistStateToQuery(true);
        this.fetchProducts();
      }
    },
    refreshProducts() {
      this.fetchProducts();
    },

    async fetchProducts() {
      this.loading = true;

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      };
      Object.keys(params).forEach(k => {
        if (params[k] === '') delete params[k];
      });

      this.request({
        url: this.endpoint('shop/adminProducts'),
        method: 'get',
        params,
        success: (data) => {
          if (this.navigatingOut) return;
          this.products = data.results || [];
          this.totalProducts = data.count || 0;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
    },

    // ---- meta fetch ----
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data || [];
        }
      });
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data || [];
        }
      });
    },
    fetchFeatures() {
      this.request({
        url: this.endpoint('product/featureTree'),
        method: 'get',
        success: (data) => {
          this.features = data || [];
        }
      });
    },
    fetchAvails() {
      this.request({
        url: this.endpoint('product/availsTree'),
        method: 'get',
        success: (data) => {
          this.avails = data || [];
        }
      });
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        search_value: '',
        sku: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        status_in: '',
        content_status: '',
        catalog_need: '',
        currency_in: '',
        is_ai: null,
        supplier: ''
      };
      this.currentPage = 1;
      this.$router.replace({name: this.$route.name, query: {}});
      this.fetchProducts();
    },

    // ---- labels ----
    getStatusLabel(status) {
      const statusMap = {
        draft: 'پیش نویس',
        pr: 'نیاز به بررسی',
        pending: 'در انتظار تایید',
        publish: 'منتشر شده',
        archived: 'آرشیو'
      };
      if (!status) return ' ';
      return statusMap[status] || status;
    },
    getContentStatusLabel(content_status) {
      const map = {
        waiting: 'در انتظار محتوا',
        done_pending: 'در انتظار تأیید',
        approved: 'تأیید شده',
      };
      if (!content_status) return ' ';
      return map[content_status] || content_status;
    },

    // Quick view hooks (kept)
    handleEditProduct(product) {
      // اگر لازم داری، مسیر خودتو بذار
      // اینجا صرفاً نگه داشتم که پروژه‌ات نشکنه
      this.selectedProduct = product;
      this.showQuickView = true;
    },
  },
  mounted() {
    this.loadStateFromQuery();
    this.fetchProducts();
    this.fetchBrands();
    this.fetchCurrency();
    this.fetchFeatures();
    this.fetchAvails();
  },
  beforeRouteLeave(to, from, next) {
    this.navigatingOut = true;
    next();
  }
}
</script>

<style scoped>
/* استایل‌های قبلی + بهبود برای موبایل */
td, th, p, span, div {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* بهبود فیلترها برای موبایل */
/* موبایل stable: جلوی zoom (iOS) */
/* موبایل stable: جلوی zoom (iOS) */
select, input, textarea {
  background: rgba(15, 23, 42, 0.8) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;

  font-size: 16px !important; /* ✅ کلید اصلی */
  line-height: 20px !important; /* ✅ ارتفاع ثابت متن */
  padding: 12px 12px !important; /* ✅ پایدار */
  height: 44px !important; /* ✅ استاندارد تاچ */
  border-radius: 12px !important;
  -webkit-text-size-adjust: 100%;
}

@media (min-width: 768px) {
  select, input, textarea {
    font-size: 14px !important; /* دسکتاپ اوکیه */
    height: 40px !important;
  }
}

/* بعضی iOS ها روی select بدقلقن */
select {
  -webkit-appearance: none;
  appearance: none;
}

@media (min-width: 768px) {
  select, input, textarea {
    font-size: 14px !important; /* دسکتاپ اوکیه */
    height: 40px !important;
  }
}

/* بعضی iOS ها روی select بدقلقن */
select {
  -webkit-appearance: none;
  appearance: none;
}

select option {
  background: rgba(15, 23, 42, 0.95) !important;
}

/* کارت‌های محصول */
.bg-white.bg-opacity-70 {
  background: rgba(2, 6, 23, 0.65) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
}

/* دکمه‌های عملیات بزرگ‌تر برای موبایل */
@media (max-width: 767px) {
  .p-2\.5 {
    padding: 12px !important;
  }

  .h-5.w-5 {
    height: 22px !important;
    width: 22px !important;
  }

  /* چک‌باکس بزرگ‌تر */
  input[type="checkbox"] {
    height: 24px !important;
    width: 24px !important;
  }
}

/* دیالوگ‌ها */
::v-deep .dark-v-dialog .v-card {
  background: rgba(2, 6, 23, 0.78) !important;
  border: 1px solid rgba(255, 255, 255, 0.10) !important;
  backdrop-filter: blur(18px) saturate(160%) !important;
  -webkit-backdrop-filter: blur(18px) saturate(160%) !important;
  color: rgba(226, 232, 240, 0.95) !important;
}

</style>